import { ActionController, ActionControllerEventName } from "@g.frame/common.action_controller";
import { Loader, TEXTURE } from "@g.frame/common.loaders";
import { TextComponent } from "@g.frame/components.text";
import { WindowComponent } from "@g.frame/components.window";
import { ParentEvent, ViewerModule } from "@g.frame/core";
import { DesktopModule } from "@g.frame/desktop";
import { Color, Group, Mesh, MeshBasicMaterial, PlaneBufferGeometry, Vector2 } from "three";
export default class SliderComponent extends ViewerModule {
    constructor(modulesProcessor) {
        super();
        this.modulesProcessor = modulesProcessor;
        this.mainContainer = new Group;
        this.labelsContainer = new Group;
        this.valuesConfig = [];
        this.loader = this.modulesProcessor.agents.get(Loader);
        this.actionController = this.modulesProcessor.agents.get(ActionController);
        this.controls = this.modulesProcessor.modulesInstances.get(DesktopModule)[1];
        this.loader.addResources([
            {
                name: 'TEXTURE_plus_icon',
                url: require('../../../assets/textures/icons/plus.png'),
                type: TEXTURE
            },
            {
                name: 'TEXTURE_minus_icon',
                url: require('../../../assets/textures/icons/minus.png'),
                type: TEXTURE
            },
        ]);
        this.baseSize = new Vector2(0.8, 0.075);
        this.addObject(this.mainContainer);
    }
    setOptions(config, rightValue) {
        while (this.labelsContainer.children.length) {
            this.labelsContainer.remove(this.labelsContainer.children[0]);
        }
        this.rightValue = rightValue;
        this.valuesConfig = [];
        const step = this.baseSize.x / (config.length - 1);
        const pstep = 1 / (config.length - 1);
        config.forEach((item, index) => {
            const label = this.initLabel(item);
            label.uiObject.position.x = -this.baseSize.x / 2 + step * index;
            this.labelsContainer.add(label.uiObject);
            this.valuesConfig.push({
                value: item,
                position: index * pstep,
            });
        });
        this.fire('drag_point', new ParentEvent('drag_point', { point: 0 }));
        this.updateMaterials('default');
    }
    init() {
        //BUTTONS
        const plusButton = this.createButton(this.loader.getResource('TEXTURE_plus_icon'));
        const minusButton = this.createButton(this.loader.getResource('TEXTURE_minus_icon'));
        this.actionController.on(ActionControllerEventName.click, plusButton, () => {
            const newPosition = this.currentPosition + 1 / (this.valuesConfig.length - 1);
            this.fire('drag_point', new ParentEvent('drag_point', { point: newPosition }));
        });
        this.actionController.on(ActionControllerEventName.click, minusButton, () => {
            const newPosition = this.currentPosition - 1 / (this.valuesConfig.length - 1);
            this.fire('drag_point', new ParentEvent('drag_point', { point: newPosition }));
        });
        minusButton.position.x = -0.55;
        plusButton.position.x = 0.55;
        //
        this.labelsContainer = new Group();
        this.labelsContainer.position.y = 0.09;
        this.mainContainer.add(this.labelsContainer);
        //
        const bar = this.createBar();
        this.mainContainer.add(plusButton);
        this.mainContainer.add(minusButton);
        this.mainContainer.add(bar);
        //default state
        this.fire('drag_point', new ParentEvent('drag_point', { point: 0 }));
    }
    createButton(icon) {
        const buttonGroup = new Group;
        const size = new Vector2(0.1, 0.1);
        const border = new WindowComponent({
            size: size.clone().addScalar(size.y / 10),
            bordRadius: size.y / 4,
            background: 0x5D772E
        });
        border.uiObject.position.z = -0.0001;
        const background = new WindowComponent({
            size: size,
            bordRadius: size.y / 4,
            background: 0x9DC458
        });
        const iconMesh = new Mesh(new PlaneBufferGeometry(0.08, 0.08), new MeshBasicMaterial({ transparent: true, alphaTest: 0.5, map: icon }));
        iconMesh.position.z = 0.0001;
        buttonGroup.add(background.uiObject);
        buttonGroup.add(border.uiObject);
        buttonGroup.add(iconMesh);
        return buttonGroup;
    }
    createBar() {
        const barGroup = new Group;
        const size = new Vector2(this.baseSize.x + 0.075, this.baseSize.y);
        const sizeFill = new Vector2(this.baseSize.y, this.baseSize.y);
        const background = new WindowComponent({
            size: size,
            bordRadius: size.y / 2,
            background: 0xFFFFFF
        });
        barGroup.add(background.uiObject);
        //filler
        const fillerGroup = new Group;
        fillerGroup.position.set(-this.baseSize.x / 2, 0, 0.0001);
        barGroup.add(fillerGroup);
        const fillerLeft = new WindowComponent({
            size: sizeFill,
            bordRadius: sizeFill.y / 2,
            background: 0x9DC458
        });
        // fillerLeft.uiObject.position.x = -sizeFill.x/2;
        // console.log('filler', fillerLeft);
        //@ts-ignore
        this.innerMaterial = fillerLeft.uiObject.children[0].material;
        // const filler = new Mesh(new PlaneBufferGeometry(0.08, 0.075).translate(0.04, 0, 0), new MeshBasicMaterial({color: '#9DC458'}));
        const filler = new Mesh(new PlaneBufferGeometry(0.08, 0.075).translate(0.04, 0, 0), this.innerMaterial);
        fillerGroup.add(filler);
        fillerGroup.add(fillerLeft.uiObject);
        //point
        const point = this.barPoint();
        point.position.z = 0.0003;
        point.position.x = -0.02;
        barGroup.add(point);
        const plane = this.dragInit();
        barGroup.add(plane);
        this.on('drag_point', (event) => {
            var _a;
            const p = Math.max(0, Math.min(1, event.data.point));
            const offset = 0.5 / (this.valuesConfig.length - 1);
            const initValue = {
                value: ((_a = this.valuesConfig[0]) === null || _a === void 0 ? void 0 : _a.value) || '',
                position: 0
            };
            const pvalue = this.valuesConfig.reduce((pv, cv) => {
                if (p < (cv.position + offset) && p > (cv.position - offset)) {
                    return {
                        value: cv.value,
                        position: cv.position
                    };
                }
                else {
                    return pv;
                }
            }, initValue);
            this.value = pvalue.value;
            if (this.value === this.rightValue) {
                this.updateMaterials('valid');
            }
            else {
                this.updateMaterials('error');
            }
            this.currentPosition = pvalue.position;
            point.position.x = pvalue.position * this.baseSize.x - this.baseSize.x / 2;
            const sx = (pvalue.position / 0.1);
            filler.scale.set(sx, 1, 1);
        });
        return barGroup;
    }
    barPoint() {
        const pointGroup = new Group();
        const size = new Vector2(0.075, 0.075);
        const border = new WindowComponent({
            size: size.clone().addScalar(size.y / 12),
            bordRadius: size.y / 2,
            background: 0x5D772E
        });
        border.uiObject.position.z = -0.0001;
        const background = new WindowComponent({
            size: size,
            bordRadius: size.y / 2,
            background: 0x9DC458
        });
        // console.log('point', background);
        //@ts-ignore
        this.pointMaterial = background.uiObject.children[0].material;
        //@ts-ignore
        this.pointBorderMaterial = border.uiObject.children[0].material;
        pointGroup.add(background.uiObject);
        pointGroup.add(border.uiObject);
        // const label = this.initLabel();
        // pointGroup.add(label.uiObject);
        // label.uiObject.position.set(0, 0.09, 0);
        return pointGroup;
    }
    updateMaterials(mode) {
        const config = {
            valid: {
                base: new Color(0x9DC458),
                border: new Color(0x5D772E),
            },
            error: {
                base: new Color(0xFDD1D1),
                border: new Color(0xDB5B4A),
            },
            default: {
                base: new Color(0xE5E6E0),
                border: new Color(0xC2C0BC),
            },
        };
        const state = config[mode] || config.default;
        this.innerMaterial.color.copy(state.base);
        this.pointMaterial.color.copy(state.base);
        this.pointBorderMaterial.color.copy(state.border);
    }
    initLabel(text) {
        const label = new TextComponent({
            size: new Vector2(0.16, 0.08),
            pxSize: new Vector2(512, 256),
            text: {
                value: text,
                autoWrappingHorizontal: false,
                autoWrapping: true,
                align: 'center',
                style: {
                    family: 'Ubuntu',
                    weight: '700',
                    size: '140px',
                    color: '#432A1C',
                },
                lineHeight: 140,
            },
            background: {
                color: 'transparent'
            }
        });
        return label;
    }
    calcValue() {
        // return ((this.maxValue - this.minValue) * this.value).toFixed( this.maxValue > 1 ? 0 : 2);
        return this.value;
    }
    dragInit() {
        const size = new Vector2(this.baseSize.x, 0.15);
        const plane = new Mesh(new PlaneBufferGeometry(size.x + 0.1, size.y), new MeshBasicMaterial({ side: 2, color: '#44ee44', visible: false }));
        const pointCalculation = (event) => {
            const point = plane.worldToLocal(event.data.intersection.point);
            const step = (point.x + size.x / 2) / size.x;
            const ps = Math.max(0, Math.min(1, step));
            this.fire('drag_point', new ParentEvent('drag_point', { point: ps }));
        };
        let dragEnabled = false;
        this.actionController.on(ActionControllerEventName.buttonDown, plane, (event) => {
            dragEnabled = true;
            this.controls.enabled = false;
            pointCalculation(event);
        });
        this.actionController.on(ActionControllerEventName.buttonUp, plane, () => {
            dragEnabled = false;
            this.controls.enabled = true;
        });
        this.actionController.on(ActionControllerEventName.move, plane, (event) => {
            if (dragEnabled) {
                pointCalculation(event);
            }
        });
        this.actionController.on(ActionControllerEventName.out, plane, () => {
            dragEnabled = false;
            this.controls.enabled = true;
        });
        return plane;
    }
}
